import {
  Component,
  computed,
  input,
  ChangeDetectionStrategy,
} from '@angular/core';

import {
  formatJsonValue,
  isJsonBranch,
  isJsonContainer,
} from '../json-value.utils';

interface JsonTreeEntry {
  key: string;
  /** nested object/array — rendered by a child tree */
  branch?: unknown;
  /** printable value — rendered inline or as a block */
  text?: string;
  multiline?: boolean;
}

/**
 * Renders any JSON value as a labelled tree. Recurses into itself for nested
 * containers; multi-line strings (stack traces, request traces) keep their line breaks.
 */
@Component({
  selector: 'app-json-tree',
  standalone: false,
  templateUrl: './json-tree.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './json-tree.component.scss',
})
export class JsonTreeComponent {
  value = input.required<unknown>();

  entries = computed<JsonTreeEntry[]>(() => {
    const value = this.value();
    if (!isJsonContainer(value)) return [];

    return Object.entries(value).map(([key, child]) => {
      if (isJsonBranch(child)) {
        return { key, branch: child };
      }

      const text = formatJsonValue(child);
      return { key, text, multiline: text.includes('\n') };
    });
  });
}
